import { render, staticRenderFns } from "./FormMed.vue?vue&type=template&id=f5da3542&"
import script from "./FormMed.vue?vue&type=script&lang=js&"
export * from "./FormMed.vue?vue&type=script&lang=js&"
import style0 from "./FormMed.vue?vue&type=style&index=0&id=f5da3542&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports